package gr.tech.site.pages

class DynamicPage(route: String) : SitePage(route)

sealed class SitePage(val route: String) {

    data object Home: SitePage(route = "/")
    data object ContactUs: SitePage(route = "/contact-us")

    data object TermsConditions: SitePage(route = "/terms-conditions")
    data object PrivacyPolicy: SitePage(route = "/privacy-policy")
    data object Partners: SitePage(route = "/partners")
    data object MeetTheTeam: SitePage(route = "/meet-the-team") {
        fun entryPerson(person: String) = "$route/${person}"
    }

    data object Blog: SitePage(route = "/blog") {
        fun entryRoute(routeOverride: String) = "$route/$routeOverride"
    }

    data object Article: SitePage(route = "/article") {
        fun entryRoute(routeOverride: String) = "$route/$routeOverride"
    }

    data object Podcast: SitePage(route = "/podcast")


    /* Can't use in page override, because not compile time constant (???) */

    // States
    data object States {
        const val MICHIGAN: String = "/states/michigan"
    }

    // Landing Pages
    data object Landing  {
        const val OUR_SERVICES: String = "/our-services"
        const val CANNABIS_REBATES: String = "/cannabis-rebates"
        const val LED_GROW_LIGHT_REBATES: String = "/led-grow-light-rebates"

        const val DEHUMIDIFIER_REBATES: String = "/dehumidifier-rebates"
        const val HVAC_REBATES: String = "/hvac-rebates"
        const val FINANCING: String = "/financing"
        const val DLC_QUALIFIED_REBATES: String = "/dlc-qualified-rebates"
    }


}

